import { UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './InlineFilterSection.css';

interface IFilterSectionProps {
  title: string | null;
}

export const FilterSection: React.FC<React.PropsWithChildren<IFilterSectionProps>> = ({ title, children }) => {
  return (
    <div className={styles['section']}>
      {title && (
        <div className={styles['title']}>
          <UIHeading5>{title}</UIHeading5>
        </div>
      )}
      <div className={styles['content']}>{children}</div>
    </div>
  );
};
